import React, { useEffect, useCallback, useRef, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import axiosInstance from './api/axios';
import { BASE_URL } from './constants/apiConstants';

const App: React.FC = () => {
  const { instance } = useMsal();
  const refreshTimeoutRef = useRef<NodeJS.Timeout | null>(null);  
  const [expireTime, setExpireTime] = useState<any>()
  useEffect(() => {
    if (window.top && window.top !== window.self) {
      window.top.location.href = window.location.href;
    }
  }, []);


  useEffect(() => {
  if (window.top && window.top !== window.self) {
    window.top.location.href = window.location.href;
  }
}, []);

  const handleWheel = useCallback((e: WheelEvent) => {
    const activeElement = document.activeElement as HTMLInputElement | null;
    if (activeElement?.type === 'number') {
      activeElement.blur();
    }
  }, []);

  useEffect(() => {
    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, [handleWheel]);

  useEffect(() => {  
    // refreshTimeOut()
    refreshTimeoutRef.current = setInterval(() => {
      refreshToken();
    }, 30 * 60 * 1000); // 30 minutes in milliseconds, Token refresh
    return () => {
      if (refreshTimeoutRef.current) {
        clearTimeout(refreshTimeoutRef.current);
      }
    };
  }, [instance, expireTime]);

  // const refreshTimeOut = () => {
  //   const accounts = instance.getAllAccounts();
  //   const storedExpiry = localStorage.getItem("tokenExpiresOn");
  //       console.log("fresh 12");

  //   // debugger
  //   if (accounts.length > 0 && storedExpiry) {
  //     const expiresOn = new Date(storedExpiry); // from MSAL
  //     const bufferTime = 73 * 60 * 1000; // 5 minute before refresh
  //     console.log("fresh 13");

  //     // Calculate delay until refresh (in milliseconds)
  //     const timeUntilExpiry = expiresOn.getTime() - Date.now() - bufferTime;
  //     // debugger
  //     if (timeUntilExpiry > 0) {
  //           console.log("fresh 14");

  //       // Calculate when to refresh (5 minutes before expiry)
  //       const refreshTime = timeUntilExpiry
  //       console.log("Setting token refresh timeout for", refreshTime / 1000, "seconds");
  
  //       refreshTimeoutRef.current = setTimeout(() => {
  //         refreshToken();
  //       }, Math.max(refreshTime, 0));
  //     } else {
  //       console.log("Token expired, redirecting to login.");
  //       instance.loginRedirect();
  //     }
  
  //   }
  // }


  const refreshToken = async () => {
  console.log("Attempting to refresh token...");
  const accounts = instance.getAllAccounts();
  if (accounts.length > 0) {
    const silentRequest = {
      scopes: ["User.Read"], // adjust scopes as needed
      account: accounts[0],
      forceRefresh: true
    };
    try {
      const tokenResponse: any = await instance.acquireTokenSilent(silentRequest);
      console.log("Token refreshed successfully:", tokenResponse);

      localStorage.setItem("token", tokenResponse.accessToken);
      localStorage.setItem("tokenExpiresOn", tokenResponse.extExpiresOn?.toString());
      setExpireTime(tokenResponse.extExpiresOn?.toString())
      // Save or update token to API
      const saveTokenResponse: any = await axiosInstance.post(
        `${BASE_URL}/api/v1/Auth/SaveOrUpdateUserToken`,
           {
            userid: localStorage.getItem("userid"),
            accesstoken: tokenResponse.accessToken,
            refreshtoken: "", // Use the refresh token from local storage 
            expirydate: tokenResponse.extExpiresOn,
          }
          ,{
            headers: {
              'X-API-KEY': 'cilantro3protectedkey' 
            }
          }
      );

      if (saveTokenResponse.data?.success) {
        // refreshTimeOut()
        console.log("Access token saved successfully.");
      } else {
        toast("Failed to save access token.", { type: "error" });
      }
    } catch (error) {
      console.error("Token refresh failed:", error);
      toast("Token refresh failed. Please log in again.", { type: "error" });
      await instance.loginRedirect();
    }
  } else {
    console.warn("No accounts found to refresh token for.");
  }
};


  return (
    <ErrorBoundary>
      <Router>
        <AppRoutes />
      </Router>
    </ErrorBoundary>
  );
};

export default App;
